import { isEmpty, omit, pick } from 'lodash';
import qs from 'qs';
import { useLocation } from 'react-router-dom';

const useFromMenuUrlParams = ({
  excludeKeys,
  includeKeys,
  parseOptions = {},
}: {
  excludeKeys?: Array<string>;
  includeKeys?: Array<string>;
  parseOptions?: qs.IParseOptions;
}) => {
  const { search, state } = useLocation();
  const { fromMenu, search: fromMenuSearch } = state ?? {};
  let query = {};
  let shouldUpdateFromMenuState = false;

  if (fromMenu) {
    // check if there are any params in the url, when empty means that the
    // user has navigated to the /people path
    if (fromMenuSearch) {
      query = qs.parse(search, { ignoreQueryPrefix: true, ...parseOptions });
      if (excludeKeys) {
        shouldUpdateFromMenuState = !isEmpty(omit(query, excludeKeys));
      }
      if (includeKeys) {
        shouldUpdateFromMenuState = !isEmpty(pick(query, includeKeys));
      }
    } else {
      shouldUpdateFromMenuState = true;
    }
  }

  function shouldUpdateFromMenu() {
    if (shouldUpdateFromMenuState) {
      shouldUpdateFromMenuState = false;

      return true;
    }

    return false;
  }

  return { fromMenu, query, search, shouldUpdateFromMenu };
};

export default useFromMenuUrlParams;
